import React from "react";

const PrivacyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex justify-center items-center z-50">
      <div
        className="max-w-3xl w-full p-8 rounded-lg overflow-y-auto max-h-[85vh]"
        style={{ backgroundColor: "#0f172a", color: "white" }}
      >
        <div className="flex justify-between mb-6">
          <h2 className="text-2xl font-bold" style={{ color: "#D4AF37" }}>
            Privacy Policy
          </h2>

          <button onClick={onClose} className="text-xl font-bold text-white">
            ✕
          </button>
        </div>

        <p className="mb-4">
          At <b>Guru Maa Pooja Sharma</b>, we value your privacy and are
          committed to protecting your personal information. This Privacy Policy
          explains how we collect, use, and safeguard your information when you
          visit our website or use our services.
        </p>

        <hr className="my-4 border-gray-600" />

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          1. Information We Collect
        </h3>
        <p>We may collect the following information:</p>
        <ul className="list-disc pl-6">
          <li>Name</li>
          <li>Phone number</li>
          <li>Email address</li>
          <li>
            Any details you provide related to your problem (love, marriage,
            career, etc.)
          </li>
        </ul>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          2. How We Use Your Information
        </h3>
        <p>We use your information to:</p>
        <ul className="list-disc pl-6">
          <li>Provide astrology consultation services</li>
          <li>Contact you via call, WhatsApp, or email</li>
          <li>Respond to your queries and requests</li>
          <li>Improve our services and user experience</li>
        </ul>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          3. No Middleman Policy
        </h3>
        <p>
          We ensure <b>direct consultation with Guru Maa</b>. Your information
          is not shared with any third-party agents or intermediaries.
        </p>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          4. Data Protection
        </h3>
        <p>
          We take appropriate security measures to protect your personal data
          from unauthorized access, misuse, or disclosure.
        </p>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          5. Sharing of Information
        </h3>
        <p>
          We do <b>not sell, trade, or rent</b> your personal information to
          others.
        </p>
        <p>We may only share information if required by law.</p>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          6. Cookies
        </h3>
        <p>
          Our website may use cookies to enhance your browsing experience. You
          can choose to disable cookies through your browser settings.
        </p>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          7. Third-Party Services
        </h3>
        <p>
          We may use third-party tools (such as Google Ads, analytics tools) to
          improve our services. These services may collect non-personal data as
          per their policies.
        </p>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          8. Your Consent
        </h3>
        <p>By using our website, you consent to our Privacy Policy.</p>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          9. Contact Us
        </h3>
        <p>
          If you have any questions regarding this Privacy Policy, you can
          contact us:
        </p>
        <p className="mt-2">
          <b>Guru Maa Pooja Sharma</b>
          <br />
          Website: https://gurumaapooja.com
          <br />
          Phone/WhatsApp: +971 541873527
        </p>

        <h3 className="font-semibold mt-4" style={{ color: "#D4AF37" }}>
          10. Updates to This Policy
        </h3>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page.
        </p>
      </div>
    </div>
  );
};

export default PrivacyModal;
